import React, { useState, useRef, useEffect } from 'react';

const nodeCoordinates = [
    // 上级节点
    {
        x: 200,
        y: 150,
        r: 50,
        fillStyle: "#6bcaff",
        arrowFromX: 250,
        arrowFromY: 150,
        arrowToX: 430,
        arrowToY: 150,
        arrowColor: "#f94a56",
        key: "downCount",
        type: 1
    },
    // 反向配件
    {
        x: 330,
        y: 60,
        r: 40,
        fillStyle: "#aefbf0",
        arrowFromX: 360,
        arrowFromY: 83,
        arrowToX: 435,
        arrowToY: 130,
        arrowColor: "#f94a56",
        key: "partInCount",
        type: 6
    },
    // 反向灵感
    {
        x: 330,
        y: 240,
        r: 40,
        fillStyle: "#ffcaca",
        arrowFromX: 360,
        arrowFromY: 217,
        arrowToX: 435,
        arrowToY: 170,
        arrowColor: "#f94a56",
        key: "insInCount",
        type: 4
    },
    // 下级节点
    {
        x: 760,
        y: 150,
        r: 50,
        fillStyle: "#6bcaff",
        arrowFromX: 530,
        arrowFromY: 150,
        arrowToX: 710,
        arrowToY: 150,
        arrowColor: "#0b03fd",
        key: "upperCount",
        type: 2
    },
    // 正向配件
    {
        x: 630,
        y: 60,
        r: 40,
        fillStyle: "#aefbf0",
        arrowFromX: 525,
        arrowFromY: 130,
        arrowToX: 600,
        arrowToY: 83,
        arrowColor: "#0b03fd",
        key: "partOutCount",
        type: 5
    },
    // 正向灵感
    {
        x: 630,
        y: 240,
        r: 40,
        fillStyle: "#ffcaca",
        arrowFromX: 525,
        arrowFromY: 170,
        arrowToX: 600,
        arrowToY: 217,
        arrowColor: "#0b03fd",
        key: "insOutCount",
        type: 3
    },
    {
        x: 480,
        y: 150,
        r: 50,
        fillStyle: "rgba(0, 0, 0, 0)",
        key: "word"
    }
];

const relationTypes = [
    '上级节点',
    '下级节点',
    '正向灵感',
    '反向灵感',
    '正向配件',
    '反向配件',
]

export default React.memo((props) => {
    const { nodeInfo, setRelationType } = props;
    const [pointer, setPointer] = useState(false);
    const [title, setTitle] = useState('');
    let _canvas = useRef(null);

    useEffect(() => {
        if (!nodeInfo) return;
        _canvas.current.height = _canvas.current.height; // 清空画板
        let ctx = _canvas.current.getContext('2d');
        
        for (let i = 0, len = nodeCoordinates.length; i < len; i++) {
            const nodeCoordinate = nodeCoordinates[i];
            /*==== 画圆（开始）====*/
            ctx.beginPath();
            ctx.arc(nodeCoordinate.x, nodeCoordinate.y, nodeCoordinate.r, 0, Math.PI*2, true);
            ctx.closePath();
            /*==== 画圆（结束）====*/
            /*==== 画圆边（开始）====*/
            ctx.strokeStyle = "#b3bfc6";
            ctx.lineWidth = 1;
            ctx.lineJoin = 'round';
            ctx.stroke();
            /*==== 画圆边（结束）====*/
            /*==== 填充圆（开始）====*/
            ctx.fillStyle = nodeCoordinate.fillStyle;
            ctx.fill();
            /*==== 填充圆（结束）====*/
            ctx.translate(0.5, 0.5); // 抗锯齿
            /*==== 添加字体（开始）====*/
            ctx.textAlign = 'center';//定义字体居中;
            ctx.textBaseline = "middle";//定义字体垂直居中;
            ctx.font = 'normal normal normal 14px Arial';
            ctx.fillStyle = "#000";
            if (nodeCoordinate.key == 'word') {
                ctx.fillText(nodeInfo.centerNodeTag.word, nodeCoordinate.x, nodeCoordinate.y);
            } else {
                ctx.fillText(nodeInfo[nodeCoordinate.key], nodeCoordinate.x, nodeCoordinate.y);
            }
            
            /*==== 添加字体（结束）====*/

            if (!nodeCoordinate.arrowFromX) {
                continue;
            }

            /*==== 画箭头线（开始）====*/
            let headlen = 15;//自定义箭头线的长度
            let theta = 30;//自定义箭头线与直线的夹角，个人觉得45°刚刚好
            let arrowX, arrowY;//箭头线终点坐标
            // 计算各角度和对应的箭头终点坐标
            let angle = Math.atan2(nodeCoordinate.arrowFromY - nodeCoordinate.arrowToY, nodeCoordinate.arrowFromX - nodeCoordinate.arrowToX) * 180 / Math.PI;
            let angle1 = (angle + theta) * Math.PI / 180;
            let angle2 = (angle - theta) * Math.PI / 180;
            let topX = headlen * Math.cos(angle1);
            let topY = headlen * Math.sin(angle1);
            let botX = headlen * Math.cos(angle2);
            let botY = headlen * Math.sin(angle2);

            ctx.lineWidth = 4;
            ctx.beginPath();
            //画直线
            ctx.moveTo(nodeCoordinate.arrowFromX, nodeCoordinate.arrowFromY);
            ctx.lineTo(nodeCoordinate.arrowToX, nodeCoordinate.arrowToY);

            arrowX = nodeCoordinate.arrowToX + topX;
            arrowY = nodeCoordinate.arrowToY + topY;
            //画上边箭头线
            ctx.moveTo(arrowX, arrowY);
            ctx.lineTo(nodeCoordinate.arrowToX, nodeCoordinate.arrowToY);

            arrowX = nodeCoordinate.arrowToX + botX;
            arrowY = nodeCoordinate.arrowToY + botY;
            //画下边箭头线
            ctx.lineTo(arrowX, arrowY);
            
            ctx.strokeStyle = nodeCoordinate.arrowColor;
            ctx.stroke();
            /*==== 画箭头线（结束）====*/
        }

    }, [nodeInfo]);

    const bindClick = e => {
        var e = e || window.event,
        clientX = e.pageX - e.target.offsetLeft,
        clientY = e.pageY - e.target.offsetTop;

        for (let i = 0, len = nodeCoordinates.length; i < len; i++) {
            let nodeCoordinate = nodeCoordinates[i],
            x = nodeCoordinate.x - clientX,
            y = nodeCoordinate.y - clientY,
            r = nodeCoordinate.r,
            isMove = Math.sqrt(x * x + y * y);
            if (isMove < r) {
                if (nodeCoordinate.type) {
                    setRelationType(nodeCoordinate.type);
                }
                break;
            }
        }
    };

    const bindMouseMove = e => {
        var e = e || window.event,
        clientX = e.pageX - e.target.offsetLeft,
        clientY = e.pageY - e.target.offsetTop,
        isShowPointer = false,
        _title = ""

        for (let i = 0, len = nodeCoordinates.length; i < len; i++) {

            let nodeCoordinate = nodeCoordinates[i],
            x = nodeCoordinate.x - clientX,
            y = nodeCoordinate.y - clientY,
            r = nodeCoordinate.r,
            isMove = Math.sqrt(x * x + y * y);
            if (isMove < r && nodeCoordinate.type) {
                isShowPointer = true;
                _title = relationTypes[nodeCoordinate.type - 1];
                break;
            }
        }

        setTitle(_title);
        setPointer(isShowPointer);
    }
   
    return (
        <canvas ref={_canvas} width="850" height="300" onClick={bindClick} onMouseMove={bindMouseMove} style={{cursor: pointer ? 'pointer' : 'default'}} title={title}></canvas>
    )
});